import React, { useState } from "react";

import baseURL from '../config';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ 
      ...formData, 
      [e.target.name]: e.target.value 
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Send the form data to your backend API
    fetch(`${baseURL}/api/contact/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(formData)
    })
      .then((res) => res.json())
      .then(() => {
        setSubmitted(true);
        setFormData({ name: "", email: "", message: "" });
      })
      .catch((err) => {
        console.error("Error submitting form:", err);
      });
  };

  return (
    <section className="py-5 bg-white">
      <div className="container">
        <h2 className="text-center mb-4">Contact Us</h2>

        <div className="row">
          {/* Contact Info */}
          <div className="col-md-6 mb-4">
            <h5>Our Address</h5>
            <p>123, Somadhan IT Road<br />Dhaka, Bangladesh</p>

            <h5>Email</h5>
            <p>info@somadhanit.com</p>

            <h5>Phone</h5>
            <p>+880 1234-567890</p>
          </div>

          {/* Contact Form */}
          <div className="col-md-6">
            {submitted ? (
              <div className="alert alert-success">
                Thanks! Your message has been sent.
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Message</label>
                  <textarea
                    className="form-control"
                    rows="4"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>

                <button type="submit" className="btn btn-primary">
                  Send Message
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
